import {relayEnvironmentWithMissingFieldHandlerForNode} from '@github-ui/relay-environment'
import {IS_BROWSER} from '@github-ui/ssr-utils'

type DashboardRelayEnvironment = ReturnType<typeof relayEnvironmentWithMissingFieldHandlerForNode>

let browserEnvironment: DashboardRelayEnvironment | undefined

/**
 * The Relay environment backing Relay-based issue UI on the dashboard, created once per page load.
 *
 * Never shared on the server: in the long-lived Alloy process a single environment would
 * accumulate every request's data and never be collected, which is what the
 * `no-module-scoped-relay-environment` rule exists to prevent.
 */
export function getDashboardRelayEnvironment(): DashboardRelayEnvironment {
  if (!IS_BROWSER) return relayEnvironmentWithMissingFieldHandlerForNode()

  browserEnvironment ??= relayEnvironmentWithMissingFieldHandlerForNode()
  return browserEnvironment
}
